<template>
    <app-layout title="Afdelingen">
        <template #header>
            <page-title title="Afdelingen" />
        </template>

        <template #pageContent>
            <Modal
                buttonClass="edit"
                buttonSize="small"
                ref="modalUpdate"
                visible="none"
            >
                <div>
                    <Form @submitted="updateDepartment()">
                        <h3>Afdeling wijzigen</h3>
                        <Input name="edit-id"  v-model="form2.id" type="hidden"/>
                        <Input label="Afdeling" name="edit-department"  v-model="form2.department" required/>
                        <Button
                            text="Afdeling wijzigen"
                            buttonType="submit"
                            buttonClass="save"
                            :loading="form2.processing"
                            class="float-right mt-5"
                        />
                    </Form>
                </div>
            </Modal>

            <div id="departments" class="w-1/3">
                <Input type="search" placeholder="Afdeling zoeken" v-model="searchDepartment" name="search-department"/>
                <Table id="departments-overview" :values="filteredDepartments">
                    <thead>
                    <Th id="department">Afdeling</Th>
                    <Th id="updated_at">Laatste wijziging</Th>
                    <Th :sort="false" class="text-right">
                        <Modal
                            buttonClass="add"
                            buttonSize="small"
                            ref="modalAdd"
                        >
                            <div>
                                <Form @submitted="createDepartment">
                                    <h3>Afdeling toevoegen</h3>
                                    <Input label="Afdeling" name="add-department"  v-model="form.department" required/>
                                    <Button
                                        text="Afdeling toevoegen"
                                        buttonType="submit"
                                        buttonClass="save"
                                        :loading="form.processing"
                                        class="float-right mt-5"
                                    />
                                </Form>
                            </div>
                        </Modal>
                    </Th>
                    </thead>
                    <tbody v-if="filteredDepartments.length > 0">
                        <tr v-for="department in state.sortedValues['departments-overview']" :key="department.id">
                            <Td v-if="department.deleted_at" class="line-through">{{ department.department }}</Td>
                            <Td v-else>{{ department.department }}</Td>
                            <Td>{{ moment(department.updated_at).format('DD/MM/YYYY HH:mm') }}</Td>
                            <Td class="text-right" v-if="department.deleted_at">
                                <Button
                                    buttonClass="redo"
                                    size="small"
                                    title="Afdeling herstellen"
                                    @click="restoreDepartment(department)"
                                    class="inline"
                                /><br>
                            </Td>
                            <Td class="text-right" v-else>
                                <Button
                                    buttonClass="edit"
                                    size="small"
                                    title="Afdeling aanpassen"
                                    @click="updateForm2(department)"
                                    class="inline"
                                />
                                <Button
                                    buttonClass="delete"
                                    size="small"
                                    title="Afdeling verwijderen"
                                    @click="deleteDepartment(department)"
                                    class="inline"
                                /><br>
                            </Td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Td from '@/Components/Td.vue'
import Th from '@/Components/Th.vue'
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Input from '@/Components/Input.vue'
import Form from '@/Components/Form.vue'

import { useForm } from '@inertiajs/inertia-vue3';
import store from '@/store'
import moment from "moment";
import { ref } from 'vue'
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Table,
        Td,
        Th,
        Button,
        Modal,
        Input,
        Form
    },
    props:[
        'departments'
    ],
    data() {
        return {
            searchDepartment: '',
        };
    },
    setup (props){
        const modalUpdate = ref(null)
        const modalAdd = ref(null)

        let form = useForm({
            'department': null
        })
        let form2 = useForm({
            'id' : null,
            'department': null
        })

        function updateDepartment(){
            form2.put('/admin/departments/' + form2.id, {
                onSuccess: () => {
                    modalUpdate.value.show = false
                    form2.reset()
                },
            })
        }

        function createDepartment(){
            form.post('/admin/departments', {
                onSuccess: () => {
                    modalAdd.value.show = false
                    form.reset()
                },
            })
        }

        function deleteDepartment(department){
            Inertia.delete('/admin/departments/' + department.id)
        }

        function restoreDepartment(department){
            Inertia.put('/admin/departments/' + department.id + '/restore')
        }

        function updateForm2(department){
            form2.id = department.id
            form2.department = department.department
            modalUpdate.value.show = true
        }

        return {
            state: store.state,
            ...store,
            form,
            form2,
            updateDepartment,
            createDepartment,
            deleteDepartment,
            restoreDepartment,
            updateForm2,
            modalUpdate,
            modalAdd
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
        filteredDepartments(){
            return this.departments.filter(department => {
                return department.department.toLowerCase().includes(this.searchDepartment.toLowerCase())
            })
        },
    },
}

</script>
